import actions from './actions'
import mutations from './mutations'

const state = function () {
  return {
    appendPidOption: null,
    showStepperModal: null,
    isLoading: false,
    uploadModalOptions: null,
    initialTarget: null,
    appendType: null,
    stepperDataSourceTrigger: null,
    initialTargetAction: null,
    intents: null,
    demos: [],
  }
}

// username: state => state.username
const getters = {
  initialTarget (state) {
    return state.initialTarget
  },
  initialTargetAction (state) {
    return state.initialTargetAction
  }
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/createTarget/store/index.js